var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-text"
  }, [_vm._v(" Loading ... " + _vm._s(_vm.percentProgress.toFixed(0)) + "% ")]), _c('span', {
    staticClass: "progress-bar-progress"
  }, [_c('span', {
    staticClass: "progress-bar-progress-percent",
    style: "width: ".concat(_vm.percentProgress, "%")
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }